import { render, staticRenderFns } from "./Managements.vue?vue&type=template&id=193f5a9c"
import script from "./managements.ts?vue&type=script&lang=ts&external"
export * from "./managements.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports